<script >
export default {
  name: 'saleSiteInfo',
  data() {
    return {

    }
  },
  methods:{

  },
  created() {

  }
}
</script>

<template>
  <div class="container">
    1
  </div>
</template>

<style scoped lang="scss">
.container {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  padding-top: 90px;
  box-sizing: border-box;
}
</style>